import './index.scss';

const skillRows = [
  { label: 'Languages',         tags: ['Python', 'C++', 'Java', 'JavaScript', 'SQL', 'ABAP'] },
  { label: 'Frameworks/Tools',  tags: ['React', 'Spring Boot', 'FastAPI', 'TensorFlow', 'Docker', 'PostgreSQL', 'Git'] },
  { label: 'Machine Learning / AI', tags: ['Transfer Learning', 'Image Processing', 'Model Deployment', 'LLM APIs', 'Browser Automation'] },
];

const About = () => (
  <section id="about">
    <div className="sec-head reveal">
      <span className="sec-label">05</span>
      <h2 className="sec-title">About</h2>
    </div>

    <div className="about-grid reveal">
      <div className="about-text">
        {/* <p>
          <strong>Computer Engineering</strong> student at <strong>UBC</strong>
          , graduating <strong>June 2027</strong>.
        </p> */}
        <p>
          I enjoy building full-stack, AI, and systems software that connects technical
          depth with a clear user need. I am currently targeting 2027 new-grad software
          engineering roles.
        </p>
        <p>
          I am open to on-site, hybrid, or remote roles in <strong>Canada and the US</strong>.
        </p>
        {/* <div className="badges">
          <span className="badge green">2× Dean's List</span>
        </div> */}
      </div>

      <div className="skills-block">
        {skillRows.map((row) => (
          <div className="skill-row" key={row.label}>
            <div className="skill-row-label">{row.label}</div>
            <div className="skill-tags">
              {row.tags.map((tag) => (
                <span className="skill-tag" key={tag}>{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default About;
